export const aboutData = {
    title: "Who I am",
    description1: "My name is Samuel. I'm a Software Engineer and developer based in Texas, US.",
    description2: "I am a self-driven, focused and enthusiastic developer with a keen interest in software development and cloud computing. Because I love what I do, I have a steady source of motivation that drives me to do my best. I am highly inquisitive and loves to learn and explore new arenas.",
    image: 1
}
